//список роутов

import React from 'react';
import { Route, IndexRoute } from 'react-router';

//load main app container
import Application from './containers/Application';
import UserSignInController from './controllers/User/SignIn';
import FeedController from './controllers/FeedController';
import FeedControllerMore from './controllers/FeedControllerMore';
import ProfileController from './controllers/ProfileController';
import SupportController from './controllers/SupportController';
import BookmarkController from './controllers/BookmarkController';

export default (
<Route path="/" component={Application}>
    <IndexRoute component={UserSignInController}/>
    <Route path="/feeds" components={FeedController} />
    <Route path="/feeds/feedmore/:id" components={FeedControllerMore} />
    <Route path="/profile" components={ProfileController} />
    <Route path="/bookmarks" components={BookmarkController} />
</Route>
);



// WEBPACK FOOTER //
// ./src/routes.js